module.exports = __webpack_public_path__ + "img/zeigling8.ee43fe34.jpg";